/**
 * AAFPlayer.js
 *
 * Tratar de no agregar aquí el store, trackerManager, etc. para mantener esta lib
 * desacoplada de un react/redux o algún otro (y poderlo reusar en algún otro)
 */

import AAFPlayerEvent from './common/AAFPlayerEvent';
import * as constant from './constants';
// TODO pasar esto a react app
import Utils from './../utils/Utils';
import ChannelsSingleton from '../components/Epg/ChannelsSingleton';
import FallbackHelper from './helpers/FallbackHelper';
import EnableSpinner from '../AAF/Spinner/EnableSpinner';
import { ThirdPartyEpgHelper } from './helpers/ThirdPartyEpgHelper';
import DeviceStorage from 'src/components/DeviceStorage/DeviceStorage';

class AAFPlayer extends AAFPlayerEvent {
  /**
   *
   * @param {*} params desde el dispatch
   * @param {*} callbacks para recuperar info del player
   * @param {*} HTMLParentWrapper tag html para agregar player y/o settear imagen de background
   */
  constructor() {
    super();

    // Bind events
    this.pause = this.pause.bind(this);
    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
    this.resume = this.resume.bind(this);
    this.skip = this.skip.bind(this);
    this.seek = this.seek.bind(this);
    this.setSpeed = this.setSpeed.bind(this);
    this.speedBackward = this.speedBackward.bind(this);
    this.speedForward = this.speedForward.bind(this);
    this.getAudioTracks = this.getAudioTracks.bind(this);
    this.setAudioTrack = this.setAudioTrack.bind(this);
    this.sendLoading = this.sendLoading.bind(this);
  }

  // Settear eventos y wrapper container
  // TODO manejar full y pip
  setup(wrapperContainer, callbacks) {
    this.wrapperContainer = wrapperContainer;
    this.callbacks = callbacks;
  }

  /**
   *
   * @param {*} options desde el dispatch "siguiente estado del player"
   */
  sendLoading(nextOptions) {
    if (EnableSpinner.disableSpinnerByContent(nextOptions)) {
      if (
        !nextOptions.clearLoading &&
        !nextOptions.isLastPip &&
        !nextOptions.isNextPip &&
        !nextOptions.sameSource
      ) {
        this.callbacks.setLoading();
      } else {
        this.callbacks.clearLoading();
      }
    }
  }

  /**
   *
   * @param {*} options desde el dispatch "siguiente estado del player"
   */
  setPlayerState(nextOptions, wrapperContainer, callbacks) {
    this.isPip = nextOptions.ispip; // TODO pegar el isPip en el dispatch/action
    switch (nextOptions.playerstate) {
      case constant.AAFPLAYER_PLAY:
        if (!Utils.isNullOrUndefined(wrapperContainer)) {
          this.wrapperContainer = wrapperContainer;
        }
        if (!Utils.isNullOrUndefined(callbacks)) {
          this.callbacks = callbacks;
        }
        if (nextOptions.islive) FallbackHelper.addPlaying();

        console.log('[TPA] AAFPlayer::setPlayerState interceptor, checking TPA...');
         // Valida si es TPA y le asigna el atributo al objeto
        const TPA = ThirdPartyEpgHelper.getThirdPartyApp(nextOptions);
        let timeToShowPlayer = 0;
        if (TPA && (typeof TPA === 'object') && TPA.type && (typeof TPA.type === 'string')) {
          const playLiveFrom = nextOptions && nextOptions.playLiveFrom;
          // Valida si se invoca la TPA desde el Carrousel Premium
          if (playLiveFrom && playLiveFrom === 'home') {
            timeToShowPlayer = 2000;
            DeviceStorage.setItem("fireTPAOnReload", nextOptions.source.videoid);
            return this.__fireTPAApp(TPA, nextOptions);
          }
          nextOptions.isTPA = TPA;
        }
        const timeoutToShowPlayer = setTimeout(() => {
          !TPA && this.sendLoading(nextOptions);
          this.__setNextPlayerState(nextOptions);
          clearTimeout(timeoutToShowPlayer);
        }, timeToShowPlayer);
        break;
      default:
      case constant.AAFPLAYER_STOP:
        let pipToStop = false;
        // Default stop el full
        if (Utils.isNullOrUndefined(nextOptions.ispip)) {
          pipToStop = false;
        } else {
          pipToStop = nextOptions.ispip;
        }
        this.stopPlayer(pipToStop);
        break;
    }
  }

  isPlayerPlaying(ispip = false) {
    /**
     * FIXME. Por el momento esto sólo funciona en kaon y huawei
     * FIXME. lms, reporta onProgress
     */
    if (!ispip) {
      if (this.playerInstance && Utils.isFunction(this.playerInstance.isPlayerPlaying)) {
        return this.playerInstance.isPlayerPlaying();
      }
    }

    return false;
  }

  /**
   * Player controls
   * NOTA IMPORTANTE & TODO: todos los comandos de abajo se van sobre el full, el pip se supone no tiene
   * playercontrols
   * ===============
   */
  play(ispip = false) {
    this.log('[AAFPlayer] play');
    // create media toma precaución del pip o full, y ya va en options params
    if (ispip) this.playerInstancePip.play();
    else this.playerInstance.play();

    // Send event if any
    if (
      this.callbacks.onPlayerControlPlay &&
      Utils.isFunction(this.callbacks.onPlayerControlPlay)
    ) {
      this.callbacks.onPlayerControlPlay(this.devicePlayerParams);
    }
  }

  pause(timeshiftAllowed) {
    var channel = window.localStorage.lastChannel;
    var liveTime = ChannelsSingleton.getTimeshift(channel);
    if (
      liveTime > 0 ||
      this.devicePlayerParams.isLive === false ||
      this.devicePlayerParams.streamType === 'radio'
    ) {
      this.log('[AAFPlayer] pause');
      this.playerInstance.pause();
      // Send event if any
      if (
        this.callbacks.onPlayerControlPause &&
        Utils.isFunction(this.callbacks.onPlayerControlPause)
      ) {
        this.callbacks.onPlayerControlPause(this.devicePlayerParams, timeshiftAllowed);
      }
    } else {
      // Si es live, también se pausa :/ async pin
      if (this.devicePlayerParams.isLive) {
        this.playerInstance.pause();
      }
    }
  }

  stop() {
    this.log('[AAFPlayer] stop');
    this.playerInstance.stop();
    if (
      this.callbacks.onPlayerControlStop &&
      Utils.isFunction(this.callbacks.onPlayerControlStop)
    ) {
      this.callbacks.onPlayerControlStop(this.devicePlayerParams);
    }
  }

  resume() {
    this.log('[AAFPlayer] resume');
    this.playerInstance.resume();
    /*
     if(!this.devicePlayerParams.isLive) {
     this.playerInstance.resume();
     }

     if(this.devicePlayerParams.isLive && this.getCurrentContentType() !== constant.AAF_CONTENT_IS_TIMESHIFT) {
     this.playerInstance.resume();
     }
     */

    if (
      this.callbacks.onPlayerControlResume &&
      Utils.isFunction(this.callbacks.onPlayerControlResume)
    ) {
      this.callbacks.onPlayerControlResume(
        this.getCurrentPlayerOptions(),
        this.getDevicePlayerParams()
      );
    }
  }

  skip(seconds) {
    this.playerInstance.seek(seconds);
  }

  seekTimeshift(timeshiftData, firstSeek) {
    this.playerInstance.seekTimeshift(timeshiftData, firstSeek);
  }

  /**
   *
   * @param {*} seekTime seconds please
   */
  seekStartOver(seekTime) {
    this.playerInstance.seekStartOver(seekTime);
  }

  seek(seconds) {
    /*
     TIMESHIFT LO TOMA PLAYERCONTROLS
     let isAudio = this.devicePlayerParams.streamType === playerConstant.AUDIO || this.devicePlayerParams.streamType === playerConstant.RADIO;
     // Hacer timeshift?
     if (this.devicePlayerParams.isLive && !isAudio) {
     if(this.callbacks.onDoTimeshift &&  Utils.isFunction(this.callbacks.onDoTimeshift)) {
     this.callbacks.onDoTimeshift(seconds, this.devicePlayerParams);
     }
     } else {
     */
    this.playerInstance.seek(seconds);
    /*
     }
     */

    if (
      this.callbacks.onPlayerControlSeek &&
      Utils.isFunction(this.callbacks.onPlayerControlSeek)
    ) {
      this.callbacks.onPlayerControlSeek(this.devicePlayerParams, seconds);
    }
  }

  /**
   *
   .    * @param {*} speed int speed, > 0 => forward, < 0 => backward
   *    setPlayerSpeed manda físicamente el speed al player
   */
  setSpeed(speed) {
    this.playerInstance.setPlayerSpeed(speed);
  }

  /**
   * playerInstance.setSpeed controla los clics del user al cambiar entre los
   * diferentes trickmodes
   */
  speedForward() {
    this.playerInstance.setSpeed(true);
  }

  speedBackward() {
    this.playerInstance.setSpeed(false);
  }

  /**
   * MULTIPLE AUDIOS
   */

  // No mandar a llamar este método desde aquí, se manda llamar "en automático cuando se intenta settear el audioTrack por primera vez
  getAudioTracks() {
    return this.playerInstance
      .getAudioTracks()
      .then(resp => {
        this.log('getAudioTracks: ');
        console.log(resp);
        this.audioTracks = resp;
      })
      .catch(e => {
        this.audioTracks = [];
        this.log('Error getAudioTracks: ');
        console.error(e);
      });
  }

  /*
   * @codeTrack i.e.: eng, spa, por, ori, etc... code with three letters...
   */
  setAudioTrack(codeTrack) {
    if (!this.audioTracksLoaded) {
      this.getAudioTracks()
        .then(resp => {
          console.log('[AAFPlayer] firstTime setAudioTrack: ' + codeTrack);
          this.audioTracks = resp;
          this.audioTracksLoaded = true;
          if (
            this.callbacks.onPlayerSetAudioTrack &&
            Utils.isFunction(this.callbacks.onPlayerSetAudioTrack)
          ) {
            this.callbacks.onPlayerSetAudioTrack(this.devicePlayerParams);
          }

          return this.playerInstance.setAudioTrack(codeTrack);
        })
        .catch(e => {
          console.log('[AAFPlayer] Error when setAudioTrack: ' + e);
          return new Promise(reject => {
            reject('[AAFPlayer] Cant get audioTracks');
          });
        });
    } else {
      this.log('Second or more setAudioTrack');
      if (
        this.callbacks.onPlayerSetAudioTrack &&
        Utils.isFunction(this.callbacks.onPlayerSetAudioTrack)
      ) {
        this.callbacks.onPlayerSetAudioTrack(this.devicePlayerParams);
      }
      return this.playerInstance.setAudioTrack(codeTrack);
    }
  }

  /*
   * @codeTrack i.e.: eng, spa, por, ori, etc... code with three letters...
   */
  setAudioTrackLive(codeTrack, subtitleTrack) {
    if (!this.audioTracksLoaded) {
      this.getAudioTracks()
        .then(resp => {
          console.log('[AAFPlayer] firstTime setAudioTrack: ', codeTrack);
          this.audioTracks = resp;
          this.audioTracksLoaded = true;
          if (
            this.callbacks.onPlayerSetAudioTrack &&
            Utils.isFunction(this.callbacks.onPlayerSetAudioTrack)
          ) {
            this.callbacks.onPlayerSetAudioTrack(this.devicePlayerParams);
          }

          return this.playerInstance.setAudioTrackLive(codeTrack, subtitleTrack);
        })
        .catch(e => {
          console.log('[AAFPlayer] Error when setAudioTrack: ' + e);
          return new Promise(reject => {
            reject('[AAFPlayer] Cant get audioTracks');
          });
        });
    } else {
      this.log('Second or more setAudioTrack');
      if (
        this.callbacks.onPlayerSetAudioTrack &&
        Utils.isFunction(this.callbacks.onPlayerSetAudioTrack)
      ) {
        this.callbacks.onPlayerSetAudioTrack(this.devicePlayerParams);
      }
      return this.playerInstance.setAudioTrackLive(codeTrack, subtitleTrack);
    }
  }

  // Util
  livePlayingAsPip() {
    // Si full
    const playerStateFull = this.getCurrentPlayingState(false);
    const playerStatePip = this.getCurrentPlayingState(true);
    let fullPlaying = false;
    let pipPlaying = false;
    // Si full
    if (playerStateFull === constant.AAFPLAYER_PLAY) {
      const playerOptionsFull = this.getCurrentPlayerOptions(false);
      if (
        playerOptionsFull &&
        playerOptionsFull.size &&
        playerOptionsFull.size.width &&
        playerOptionsFull.size.width < 1280 &&
        playerOptionsFull.islive === true &&
        !playerOptionsFull.source.hasOwnProperty('audiosource')
      ) {
        fullPlaying = true;
      }
    }

    if (playerStatePip === constant.AAFPLAYER_PLAY) {
      const playerOptionsPip = this.getCurrentPlayerOptions(true);
      if (!playerOptionsPip.source.hasOwnProperty('audiosource')) {
        pipPlaying = true;
      }
    }

    return pipPlaying || fullPlaying;
  }

  optionsPlayingAsPip(options) {
    //este metodo no distingue si es live o audio o video, solo verifica el tamaño del player para decidir si esta en pip
    return options && options.size && options.size.width && options.size.width < 1280
      ? true
      : false;
  }

  /**
   *
   * Regresa el stream content type que está playeando
   * o null si no está playeando
   */

  getCurrentStreamContentType() {
    let streamContentType = null;
    const playerStateFull = this.getCurrentPlayingState(false);
    if (playerStateFull === constant.AAFPLAYER_PLAY) {
      const playerOptionsFull = this.getCurrentPlayerOptions(false);
      if (
        playerOptionsFull &&
        Utils.isNullOrUndefined(playerOptionsFull.size) &&
        playerOptionsFull && playerOptionsFull.source &&
        !playerOptionsFull.source.hasOwnProperty('audiosource')
      ) {
        streamContentType = playerOptionsFull.streamContentType;
      }

      if (
        !streamContentType &&
        Utils.isNotNullOrNotUndefined(playerOptionsFull.size) &&
        playerOptionsFull.size.width >= 1280 &&
        !playerOptionsFull.source.hasOwnProperty('audiosource')
      ) {
        streamContentType = playerOptionsFull.streamContentType;
      }

      // ¿Es audio?
      if (streamContentType === null) {
        if (this.currentContentType) {
          streamContentType = this.currentContentType;
        }
      }
    }

    return streamContentType;
  }

  renewToken(token) {
    this.playerInstance.renewToken(token);
  }
}

export default new AAFPlayer();



// WEBPACK FOOTER //
// ./src/AAFPlayer/AAFPlayer.js